import styled, { css } from 'styled-components';

import { Box } from '@/components/Box';
import LinkWithLocale from '@/components/LinkWithLocale/LinkWithLocale';

import { ReactComponent as ArrowRight } from '@/assets/icons/arrowright-icon.svg';

const headerMenuHeight = 66;
export const Wrapper = styled(Box)`
  a {
    text-decoration: none;
    text-transform: uppercase;
    color: ${({ theme }) => theme.colors.almostBlack};
    transition: color 0.2s;
  }
`;

export const SubmenuWrapper = styled.aside<{
  isOpen: boolean;
}>`
  position: fixed;
  inset: 0;
  height: calc(100dvh - ${headerMenuHeight}px);
  padding-bottom: 10px;
  flex-direction: column;
  background: ${({ theme }) => theme.colors.white};
  backdrop-filter: ${({ theme }) => theme.components.mobileMenu.backdropFilter};
  z-index: ${({ theme }) => theme.zIndex.mobileMenu};
  overflow: auto;
  transform: ${({ isOpen }) => (isOpen ? 'translateX(0)' : 'translateX(100%)')};
  transition: transform 0.5s;
`;

export const Header = styled(Box)<{ isOpen?: boolean }>`
  display: flex;
  justify-content: space-between;
  align-items: center;
  width: 100%;
  background-color: transparent;
  text-transform: uppercase;
  font-family: ${({ theme }) => theme.fonts.subtitleFont};
  color: ${({ theme }) => theme.colors.primary};

  svg {
    color: ${(props) => props.theme.colors.primary};
  }
`;

export const List = styled.ul`
  display: flex;
  flex-direction: column;
`;

export const ListItemContent = styled.div`
  text-transform: uppercase;
  border-bottom: 1px solid ${({ theme }) => theme.colors.mediumGrey};
  & > a {
    padding: 20px 16px 15px 20px;
    display: block;
  }
  p {
    font-weight: 600;
  }
`;

export const ListItem = styled.li`
  text-transform: uppercase;
  border-bottom: 1px solid #ebebeb;
  & > a {
    padding: 20px 16px 15px 20px;
    display: block;
  }
  p {
    font-weight: 600;
  }
`;

export const LinkItem = styled(LinkWithLocale)`
  p {
    font-family: ${({ theme }) => theme.fonts.subtitleFont};
  }
`;

export const ParentItem = styled.li`
  text-transform: uppercase;
  border-bottom: 1px solid #ebebeb;
  & > button {
    font-weight: 600;
    padding: 20px 16px 15px 20px;
  }
`;

export const SubmenuHeaderWrapper = styled(ParentItem)`
  position: sticky;
  top: 0;
  z-index: 99;
  background: ${({ theme }) => theme.colors.white};
`;

export const InnerList = styled.ul`
  display: flex;
  flex-direction: column;
  gap: ${({ theme }) => theme.space.s065};
  padding-bottom: 20px;
`;

export const InnerListItem = styled.li`
  font-size: ${({ theme }) =>
    theme.components.mobileNav.innerListItem.fontSize};
  & > a {
    font-family: ${({ theme }) => theme.fonts.paragraphFont};
    font-size: 14px;
    font-style: normal;
    font-weight: 400;
    line-height: 20px;
    text-transform: initial;
    padding: 3px 0;
    border-bottom: 2px solid ${({ theme }) => theme.colors.primary};
    -webkit-mask: conic-gradient(at bottom 0px left 0px, #0000 -180deg, #000 0)
        0 var(--_i, 200%) / var(--_i, 0px) 200% border-box no-repeat,
      linear-gradient(#000 0 0) padding-box no-repeat;
    transition: 0.3s, -webkit-mask-position 0.3s 0.3s;
    &:hover {
      --_i: 100%;
      transition: 0s, -webkit-mask-size 0.3s 0.3s;
      color: ${({ theme }) => theme.colors.primaryBlue} !important;
      border-bottom: 2px solid ${({ theme }) => theme.colors.primary};
    }
  }
`;

export const ItemContent = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  width: 100%;
  height: 100%;
  padding: 20px 16px 15px 20px;
  background-color: transparent;
  text-transform: uppercase;
  color: ${({ theme }) => theme.colors.almostBlack};

  svg {
    color: ${({ theme }) => theme.colors.almostBlack};
  }

  & > p {
    font-weight: 600;
  }

  &:hover {
    cursor: pointer;
  }
`;

export const SubmenuHeader = styled(ItemContent)`
  position: relative;
  &:hover {
    cursor: pointer;
  }
  p {
    position: absolute;
    left: 50%;
    transform: translateX(-50%);
  }

  & > svg {
    transform: rotate(180deg);
  }
`;

export const Collection = styled.div`
  width: 100%;
  cursor: pointer;
  &:hover {
    img {
      -ms-transform: scale(1.3);
      -webkit-transform: scale(1.3);
      transform: scale(1.3);
    }
    p {
      color: ${({ theme }) => theme.colors.primary};
    }
  }
  img {
    transform: scale(1.2);
    transition: transform 500ms ease-in-out;
  }
  p {
    transition: color 500ms ease-in-out;
  }
`;

export const CollectionItem = styled.div`
  text-align: center;
  margin-bottom: 22px;
`;

export const IMG = styled.img`
  margin-bottom: 8px;
  width: 100%;
`;

export const CollectionTitle = styled.p`
  white-space: normal;
  font-size: 14px;
  font-weight: 400;
`;

export const CollectionBox = styled.div`
  padding-bottom: 20px;
`;

export const MobileCollectionBox = styled.div`
  display: grid;
  grid-template-columns: 1fr 1fr 1fr;
  padding: 10px 20px;
  overflow: hidden;
`;

export const LinkBox = styled.div`
  margin-bottom: 40px;
  text-align: center;
  width: 100%;
  & > a {
    text-decoration: none;
    text-transform: uppercase;
    font-size: 14px;
    white-space: nowrap;

    ${({
      theme: {
        colors: { primary, primaryBlue },
        fonts,
      },
    }) => css`
      font-family: ${fonts.paragraphFont};
      color: ${primaryBlue};
      padding-bottom: 5px;
      border-bottom: 2px solid ${primary};
      &:hover {
        color: ${primary};
      }
      transition: color 800ms ease-in-out;
    `}
  }
`;

export const ArrowRightIcon = styled(ArrowRight)``;
